import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import { FormGroupVerticalAlign } from '../constants.js';
import Field from '../Field.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinFormGroup",
  slot: "Root",
  skipForwardProps: ["columns", "verticalAlign"]
});

var GroupFieldBase = function GroupFieldBase(_ref) {
  _ref.columns;
      _ref.verticalAlign;
      var className = _ref.className;
      _ref.sx;
      _ref.variant;
      var children = _ref.children;
  return /*#__PURE__*/React.createElement(Field, {
    width: null,
    className: classnames(componentRoot.className, className)
  }, children);
};

GroupFieldBase.propTypes = {
  columns: propTypes.number,
  verticalAlign: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any,
  children: propTypes.node
};
var getVerticalFlexAlign = function getVerticalFlexAlign(verticalAlign) {
  switch (verticalAlign) {
    case FormGroupVerticalAlign.Bottom:
      return "flex-end";

    case FormGroupVerticalAlign.Middle:
      return "center";

    case FormGroupVerticalAlign.Stretch:
      return "stretch";

    case FormGroupVerticalAlign.Top:
      return "flex-start";

    default:
      return undefined;
  }
};
var GroupFieldRoot = styled(GroupFieldBase, componentRoot.styledOptions)(function (_ref2) {
  var theme = _ref2.theme,
      columns = _ref2.columns,
      verticalAlign = _ref2.verticalAlign;
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: getVerticalFlexAlign(verticalAlign),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    "> .CinForm-field": _objectSpread2({
      marginBottom: 0,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    }, columns !== undefined && columns > 0 ? {
      width: "calc(".concat(100 / columns, "% - ").concat(theme.spacing(2), ")")
    } : {
      "&.fluid": {
        width: "auto",
        flexGrow: 1,
        flexBasis: 0
      }
    }),
    "> .CinFormGroup-root": _objectSpread2({
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0
    }, columns !== undefined && columns > 0 ? {
      width: "".concat(100 / columns, "%")
    } : {
      flexGrow: 1,
      flexBasis: 0
    })
  };
});
/**
 * Groups form fields into columns
 */

var GroupField = function GroupField(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(GroupFieldRoot, rootProps);
};

var GroupField$1 = GroupField;

export { GroupField$1 as default, getVerticalFlexAlign };
